import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rss",
  "use": "rss-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"rss\">\n<path d=\"M13,21c-0.6,0-1-0.4-1-1c0-2.1-0.8-4.1-2.3-5.7C8.1,12.8,6.1,12,4,12c-0.6,0-1-0.4-1-1s0.4-1,1-1c2.7,0,5.2,1,7.1,2.9\n\tC13,14.8,14,17.3,14,20C14,20.6,13.6,21,13,21z\" />\n<path d=\"M20,21c-0.6,0-1-0.4-1-1c0-4-1.6-7.8-4.4-10.6S8,5,4,5C3.4,5,3,4.6,3,4s0.4-1,1-1c4.5,0,8.8,1.8,12,5c3.2,3.2,5,7.5,5,12\n\tC21,20.6,20.6,21,20,21z\" />\n<circle cx=\"5\" cy=\"19\" r=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol